// @flow

import {
  ONE_INSTALMENT as OneInstalmentReceipt,
  TWO_INSTALMENTS as TwoInstalmentsReceipt,
} from '../receipts/fake-receipts';

import type {
  BaseIncomingPayment,
  CanceledIncomingPayment,
  ConfirmedIncomingPayment,
  OpenedIncomingPayment,
  PendingIncomingPayment,
} from './types';

export const fakeIncomingPayment = {
  opened: (override?: (OpenedIncomingPayment) => $Shape<OpenedIncomingPayment>): OpenedIncomingPayment => fakeOpenedIncomingPayment(override),
  openedWithCountry: (override?: (OpenedIncomingPayment) => $Shape<OpenedIncomingPayment>): OpenedIncomingPayment => fakeOpenedIncomingPaymentWithCountryAllowedCards(override),
  pending: (override?: (PendingIncomingPayment) => $Shape<PendingIncomingPayment>): PendingIncomingPayment => fakePendingIncomingPayment(override),
  confirmed: (override?: (ConfirmedIncomingPayment) => $Shape<ConfirmedIncomingPayment>): ConfirmedIncomingPayment => fakeConfirmedIncomingPayment(override),
  canceled: (override?: (CanceledIncomingPayment) => $Shape<CanceledIncomingPayment>): CanceledIncomingPayment => fakeCanceledIncomingPayment(override),
};

function fakeOpenedIncomingPayment(override?: (OpenedIncomingPayment) => $Shape<OpenedIncomingPayment>): OpenedIncomingPayment {
  const openedIncomingPayment: OpenedIncomingPayment = {
    hash: 'a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6',
    name: 'Foo',
    retry: false,
    country: 'br',
    status: 'OP',
    email: 'foobar@email.com',
    document: '012.345.678-90',
    phone_number: '(12) 3456-78910',
    zipcode: '80010-180',
    address: 'Rua João Negrão',
    state: 'PR',
    city: 'Curitiba',
    street_number: '123',
    street_complement: null,
    payment_type: '',
    payment_type_code: '',
    amount_usd: 20.40,
    merchant_payment_code: '123456789',
    checkout_receipts: TwoInstalmentsReceipt,
    allowed_payment_types: ['creditcard', 'boleto', 'banktransfer'],
    payment_options: [
      { id: 'creditcard', brands: ['mastercard', 'visa', 'amex', 'hipercard', 'elo', 'diners'] },
      { id: 'boleto' },
      { id: 'banktransfer' },
    ],
    checkout_payment_options: getCheckoutPaymentOptions(),
    merchant: getIncomingPaymentMerchant(),
    card: {
      token: 'new',
      brand: 'visa',
      last_digits: '1234',
    },
    ui: {
      ignore_address: false,
      ignore_phone_number: false,
    },
    upi: {
      qr_code_value: '00020101021226570014br.gov.bcb.pix2535pix.juno.com.br/qr/1ABAA6E3387B99D1520400005303986540517.985802BR5911EBANX Ltda.6008CURITIBA62240520JNPX20201106000000036304514F',
      expiration_date: '2022-06-02 05:35:00',
      app_names: [
        'gpay',
        'phonepe',
        'paytm',
      ],
      app_links: [
        'gpay://upi//pay?pa=jptest.b20stest002@yestransact&pn=Jhow Shop&am=11.94&tr=12769536&mc=1520',
        'phonepe://upi//pay?pa=jptest.b20stest002@yestransact&pn=Jhow Shop&am=11.94&tr=12769536&mc=1520',
        'paytm://upi//pay?pa=jptest.b20stest002@yestransact&pn=Jhow Shop&am=11.94&tr=12769536&mc=1520',
      ],
    },
    one_step: {},
  };

  return {
    ...openedIncomingPayment,
    ...(override ? override(openedIncomingPayment) : null),
  };
}

function fakeOpenedIncomingPaymentWithCountryAllowedCards(override?: (OpenedIncomingPayment) => $Shape<OpenedIncomingPayment>): OpenedIncomingPayment {
  const openedIncomingPayment: OpenedIncomingPayment = {
    hash: 'a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6',
    name: 'Foo',
    retry: false,
    country: 'br',
    status: 'OP',
    email: 'foobar@email.com',
    document: '012.345.678-90',
    phone_number: '(12) 3456-78910',
    zipcode: '80010-180',
    address: 'Rua João Negrão',
    state: 'PR',
    city: 'Curitiba',
    street_number: '123',
    street_complement: null,
    payment_type: '',
    payment_type_code: '',
    amount_usd: 20.40,
    merchant_payment_code: '123456789',
    checkout_receipts: TwoInstalmentsReceipt,
    allowed_payment_types: ['creditcard', 'boleto', 'banktransfer'],
    payment_options: [
      { id: 'creditcard', brands: ['mastercard', 'visa', 'amex', 'hipercard', 'elo', 'diners'] },
      { id: 'boleto' },
      { id: 'banktransfer' },
    ],
    checkout_payment_options: getCheckoutPaymentOptions(),
    merchant: getIncomingPaymentMerchantWithCountry(),
    card: {
      token: 'new',
      brand: 'visa',
      last_digits: '1234',
    },
    ui: {
      ignore_address: false,
      ignore_phone_number: false,
    },
    upi: {
      qr_code_value: '00020101021226570014br.gov.bcb.pix2535pix.juno.com.br/qr/1ABAA6E3387B99D1520400005303986540517.985802BR5911EBANX Ltda.6008CURITIBA62240520JNPX20201106000000036304514F',
      expiration_date: '2022-06-02 05:35:00',
      app_names: [
        'gpay',
        'phonepe',
        'paytm',
      ],
      app_links: [
        'gpay://upi//pay?pa=jptest.b20stest002@yestransact&pn=Jhow Shop&am=11.94&tr=12769536&mc=1520',
        'phonepe://upi//pay?pa=jptest.b20stest002@yestransact&pn=Jhow Shop&am=11.94&tr=12769536&mc=1520',
        'paytm://upi//pay?pa=jptest.b20stest002@yestransact&pn=Jhow Shop&am=11.94&tr=12769536&mc=1520',
      ],
    },
    one_step: {},
  };

  return {
    ...openedIncomingPayment,
    ...(override ? override(openedIncomingPayment) : null),
  };
}

function fakePendingIncomingPayment(override?: (PendingIncomingPayment) => $Shape<PendingIncomingPayment>): PendingIncomingPayment {
  const pendingIncomingPayment: PendingIncomingPayment = {
    hash: '5d2f1f021a15a7f933d33c9817572eb22f6b095513678a4d',
    country: 'br',
    status: 'PE',
    boleto_url: 'https://sandbox.ebanxpay.com/print/?hash=5d2f1f2418d61bc39467d088404477ed4ee8b64789f4681f',
    boleto_barcode: '34191760072348486372714245740007579520000066600',
    boleto_barcode_raw: '34195795200000666001760023484863721424574000',
    amount_usd: 20.40,
    merchant_payment_code: '123456789',
    final_receipt: OneInstalmentReceipt.main,
    merchant: getIncomingPaymentMerchant(),
    name: 'JOAO DA SILVA',
    email: '1563369217@exemplo.com.br',
    document: '01234567890',
    zipcode: '12345-678',
    address: 'Rua',
    street_number: '1234',
    city: 'ABCDE',
    state: 'AC',
    phone_number: '41111111111',
    street_complement: null,
    payment_type: 'boleto',
    payment_type_code: 'boleto',
    pix: {
      qr_code_value: '00020101021226570014br.gov.bcb.pix2535pix.juno.com.br/qr/1ABAA6E3387B99D1520400005303986540517.985802BR5911EBANX Ltda.6008CURITIBA62240520JNPX20201106000000036304514F',
    },
    upi: {
      qr_code_value: '00020101021226570014br.gov.bcb.pix2535pix.juno.com.br/qr/1ABAA6E3387B99D1520400005303986540517.985802BR5911EBANX Ltda.6008CURITIBA62240520JNPX20201106000000036304514F',
      expiration_date: '2022-06-02 05:35:00',
      app_names: [
        'gpay',
        'phonepe',
        'paytm',
      ],
      app_links: [
        'gpay://upi//pay?pa=jptest.b20stest002@yestransact&pn=Jhow Shop&am=11.94&tr=12769536&mc=1520',
        'phonepe://upi//pay?pa=jptest.b20stest002@yestransact&pn=Jhow Shop&am=11.94&tr=12769536&mc=1520',
        'paytm://upi//pay?pa=jptest.b20stest002@yestransact&pn=Jhow Shop&am=11.94&tr=12769536&mc=1520',
      ],
    },
    one_step: {},
    expire_date: '2024-12-31 23:59:59',
  };

  return {
    ...pendingIncomingPayment,
    ...(override ? override(pendingIncomingPayment) : null),
  };
}

function fakeConfirmedIncomingPayment(override?: (ConfirmedIncomingPayment) => $Shape<ConfirmedIncomingPayment>): ConfirmedIncomingPayment {
  const confirmedIncomingPayment: ConfirmedIncomingPayment = {
    hash: '5d2f1f021a15a7f933d33c9817572eb22f6b095513678a4d',
    country: 'br',
    status: 'CO',
    amount_usd: 20.40,
    merchant_payment_code: '123456789',
    final_receipt: OneInstalmentReceipt.main,
    merchant: getIncomingPaymentMerchant(),
    name: 'JOAO DA SILVA',
    email: '1563369217@exemplo.com.br',
    document: '01234567890',
    zipcode: '12345-678',
    address: 'Rua',
    street_number: '1234',
    city: 'ABCDE',
    state: 'AC',
    phone_number: '41111111111',
    street_complement: null,
    payment_type: 'boleto',
    payment_type_code: 'boleto',
    one_step: {},
    status_date: '2021-08-01 00:30:00',
    ach_pse: {CUS: '123456', bank_name: 'itau', ticket_id: '12345'},
  };

  return {
    ...confirmedIncomingPayment,
    ...(override ? override(confirmedIncomingPayment) : null),
  };
}

function fakeCanceledIncomingPayment(override?: (CanceledIncomingPayment) => $Shape<CanceledIncomingPayment>): CanceledIncomingPayment {
  const canceledIncomingPayment: CanceledIncomingPayment = {
    amount_usd: 20.40,
    hash: '5d2f1f021a15a7f933d33c9817572eb22f6b095513678a4d',
    country: 'br',
    merchant: getIncomingPaymentMerchant(),
    name: 'JOAO DA SILVA',
    document: '01234567890',
    email: '1563369217@exemplo.com.br',
    phone_number: '41111111111',
    zipcode: '12345-678',
    address: 'Rua',
    state: 'AC',
    city: 'ABCDE',
    street_number: '1234',
    street_complement: null,
    payment_type: 'boleto',
    payment_type_code: 'boleto',
    one_step: {},
    status: 'CA',
    merchant_payment_code: '123456789',
    checkout_receipts: TwoInstalmentsReceipt,
    final_receipt: OneInstalmentReceipt.main,
    redirect_url_after_payment: 'https://google.com',
    must_redirect_after_payment: false,
    wait_before_redirect: 10000,
  };

  return {
    ...canceledIncomingPayment,
    ...(override ? override(canceledIncomingPayment) : null),
  };
}

function getIncomingPaymentMerchant(): $PropertyType<BaseIncomingPayment, 'merchant'> {
  return {
    name: 'Test - Demonstration',
    logo: 'https://s3-sa-east-1.amazonaws.com/assets-test.ebanx.com/img/merchants/EBX8HGDYW.jpg',
    public_key: 'pk_1231000',
    theme: 'default',
    facebook_pixel_ids: ['123'],
    google_analytics_tracking_ids: ['abc'],
    google_analytics_tracking_site: 'localhost',
    look_and_feel: 'volcanes',
    threedsecure: {
      allowed_cards: [],
    },
  };
}

function getIncomingPaymentMerchantWithCountry(): $PropertyType<BaseIncomingPayment, 'merchant'> {
  return {
    name: 'Test - Demonstration',
    logo: 'https://s3-sa-east-1.amazonaws.com/assets-test.ebanx.com/img/merchants/EBX8HGDYW.jpg',
    public_key: 'pk_1231000',
    theme: 'default',
    facebook_pixel_ids: ['123'],
    google_analytics_tracking_ids: ['abc'],
    google_analytics_tracking_site: 'localhost',
    look_and_feel: 'volcanes',
    threedsecure: {
      allowed_cards: [
        {
          type: 'debitcard',
        },
      ],
      allowed_cards_by_country: [
        {
          mx: [
            { creditcard: [] },
          ],
        },
        {
          br: [
            { debitcard: ['ELO', 'MASTERCARD', 'VISA'] },
            { creditcard: [] },
          ],
        },
      ],
    },
  };
}

function getCheckoutPaymentOptions(): $PropertyType<OpenedIncomingPayment, 'checkout_payment_options'> {
  return {
    creditcard: [
      'amex',
      'aura',
      'diners',
      'discover',
      'elo',
      'hipercard',
      'mastercard',
      'visa',
    ],
    tef: [
      'bancodobrasil',
      'ebanxaccount',
      'itau',
    ],
    banktransfer: [
      'banktransfer',
    ],
    cash: [
      'boleto',
    ],
    dda: [
      'dda',
    ],
    debitcard: [
      'debitcard',
    ],
    ebanxbalance: [
      'ebanxbalance',
    ],
    ewallet: [
      'paypal-recurrent',
      'mpconnect',
      'mercadopago',
      'paypal',
      'picpay',
    ],
    pix: [
      'pix',
    ],
    multibeneficios: [
      'vr-multibeneficios',
    ],
    externalpayprovider: [
      'bancolombia-button',
      'achpse',
    ],
  };
}
